<template>
  <div class="link-views white-bg">
    <div class="top">
      <Button type="primary" @click="addItemFn('editItem')">添加</Button>
    </div>
    <div class="select-div">
      <div class="mr">
        <span>选择楼栋：</span>
        <i-select v-model="pageData.BuildId" style="width:200px">
          <i-option
            v-for="item in BuildList"
            :value="item.BuildId"
            :key="item.BuildId"
          >{{ item.BuildName }}</i-option>
        </i-select>
      </div>
      <div>
        <Button type="primary" class="mr" icon="md-search" @click="searchById(pageData.BuildId)">查询</Button>
        <Button type="primary" icon="md-refresh" @click="searchById(0)">重置</Button>
      </div>
    </div>
    <div class="table-div">
      <!-- 表格 -->
      <Table :columns="columns" :data="listObj.Result" :loading="loading">
        <template slot-scope="{ row}" slot="action">
          <div class="action-table">
            <a @click="editItemFn(row)">编辑</a>
            <a @click="delItemFn(row)">删除</a>
          </div>
        </template>
      </Table>
      <!-- 分页 -->
      <div class="page-div">
        <Page
          show-total
          :total="listObj.records"
          :current="pageData.page"
          :page-size="pageData.size"
          @on-change="changePage"
        />
      </div>
    </div>
    <!-- 编辑模态框 -->
    <Modal v-model="showModal" :mask-closable="false" title="设置">
      <Form ref="editItem" :model="editItem" :label-width="90" :rules="ruleValidate">
        <FormItem label="楼层名称" prop="FloorName">
          <Input clearable v-model="editItem.FloorName"/>
        </FormItem>
        <FormItem label="楼层编号" prop="FloorNo">
          <Input clearable v-model="editItem.FloorNo"/>
        </FormItem>
        <FormItem label="所属楼栋" prop="BuildId">
          <i-select v-model="editItem.BuildId">
            <i-option
              v-for="item in BuildList"
              :value="item.BuildId"
              :key="item.BuildId"
            >{{ item.BuildName }}</i-option>
          </i-select>
        </FormItem>
        <FormItem label="楼层描述" prop="Describes">
          <Input clearable type="textarea" v-model="editItem.Describes"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="showModal=false">取消</Button>
        <Button type="primary" @click="sureEdit('editItem')">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import * as homeConst from "../../../apiconfig/index.js";
import * as homeApi from "../../../api/teacher-api.js";
export default {
  name: "floor",
  data() {
    return {
      loading: true,
      BuildList: [],
      pageData: {
        BuildId: 0,
        page: 1,
        size: 10
      },
      listObj: {},
      showModal: false,
      editApi: "",
      editItem: {},
      columns: [
        //设置表格参数
        { title: "楼层名称", key: "FloorName", align: "center" },
        { title: "楼层编号", key: "FloorNo", align: "center" },
        { title: "所属楼栋", key: "BuildName", align: "center" },
        { title: "楼栋编号", key: "BuildNo", align: "center" },
        { title: "楼层描述", key: "Describes", align: "center" },
        { title: "可选操作", slot: "action", align: "center" }
      ],
      ruleValidate: {
        FloorName: [
          { required: true, message: "楼层名称不能为空", trigger: "blur" }
        ],
        FloorNo: [
          { required: true, message: "楼层编号不能为空", trigger: "blur" }
        ],
        BuildId: [
          {
            required: true,
            type: "number",
            message: "所属楼栋不能为空",
            trigger: "change"
          }
        ],
        Describes: [
          { required: true, message: "楼层描述不能为空", trigger: "blur" }
        ]
      }
    };
  },
  mounted() {
    this.getBuildList();
    this.getpageArr(this.pageData);
  },
  methods: {
    async getBuildList() {
      this.BuildList = await homeApi.GetAllBuild();
    },
    // 获取分页数据
    async getpageArr(pageData) {
      this.listObj = await homeApi.GetFloorList({
        BuildId: pageData.BuildId ? pageData.BuildId : 0,
        page: pageData.page,
        size: pageData.size
      });
      this.loading = false;
    },
    //添加
    addItemFn(name) {
      this.$refs["editItem"].resetFields();
      this.showModal = true;
      this.editApi = "AddFloor";
      this.editItem = {};
      this.pageData.page = 1;
      this.pageData.BuildId = 0;
    },
    //编辑
    editItemFn(row) {
      this.$refs["editItem"].resetFields();
      homeApi
        .GetFloorById({
          FloorId: row.FloorId
        })
        .then(res => {
          this.editItem = res;
          this.showModal = true;
          this.editApi = "AmendFloor";
        });
    },
    // 确认编辑
    sureEdit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          homeApi[this.editApi](this.editItem).then(res => {
            if (res.success) {
              this.getpageArr(this.pageData);
              this.showModal = false;
              this.$Message.success({
                content: res.msg,
                duration: 3
              });
            } else {
              this.$Message.error({
                content: res.msg,
                duration: 3
              });
            }
          });
        } else {
          this.$Message.error({
            content: "数据不符合要求",
            duration: 3
          });
        }
      });
    },
    //删除
    delItemFn(row) {
      this.$Modal.confirm({
        title: "删除楼层",
        content: "确认删除" + row.FloorName,
        onOk: () => {
          homeApi.delFloor({ FloorId: row.FloorId }).then(res => {
            if (res.success) {
              this.pageData.page = 1;
              this.pageData.BuildId = 0;
              this.getpageArr(this.pageData);
              this.$Message.success({
                content: res.msg,
                duration: 3
              });
            } else {
              this.$Message.error({
                content: res.msg,
                duration: 3
              });
            }
          });
        }
      });
    },
    searchById(BuildId) {
      this.pageData.page = 1;
      this.pageData.BuildId = BuildId;
      this.getpageArr(this.pageData);
    },
    //分页
    changePage(page) {
      this.pageData.page = page;
      this.getpageArr(this.pageData);
    }
  }
};
</script>

<style scoped>
</style>